<div>
  <label>{{ 'profiles.contact.type' | translate | titlecase }}</label>
  <p-select
    placeholder="{{ 'common.select' | translate | titlecase }}"
    [options]="contactTypes"
    [style]="{ width: '100%' }"
    [(ngModel)]="contactModel.ContactType"
    appendTo="body"
    (onChange)="onFieldChange()"
  >
  </p-select>
</div>
<div>
  <label>{{ 'profiles.contact.contact-date' | translate | titlecase }}</label>
  <wl-date-selector [(ngModel)]="contactModel.ContactDate" appendTo="body" (onDateChanged)="onFieldChange()"></wl-date-selector>
</div>
<div>
  <label>{{ 'profiles.contact.by' | translate | titlecase }}</label>
  <wl-user-selector
    noneText="{{ 'common.select' | translate | titlecase }}"
    [(ngModel)]="contactModel.ContacteeUserNum"
    (selectedUserNumChange)="onFieldChange()"
  ></wl-user-selector>
</div>
<div>
  <label>{{ 'profiles.contact.subject' | translate | titlecase }}</label>
  <input class="form-control" [(ngModel)]="contactModel.Subject" (change)="onFieldChange()" />
</div>
<div>
  <label>{{ 'profiles.contact.description' | translate | titlecase }}</label>
  <textarea class="form-control" [(ngModel)]="contactModel.Descr" (change)="onFieldChange()"></textarea>
</div>
